import AvatarsCount from 'components/avatarsCount';
import { getAvatarItems } from 'utils/colors';
import { memo } from 'react';
import { EmptyCell } from 'components/Table';

interface ItemTeamProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
}

const Active = (props: ItemTeamProps): JSX.Element => {
  const { data } = props;

  const more = data.length - 3;

  return (
    <>
      {data?.length > 0 ? <AvatarsCount items={getAvatarItems(data)} more={more} /> : <EmptyCell />}
    </>
  );
};

export default memo(Active);
